module.exports = __webpack_public_path__ + "img/accept-terms-rafiki.9a8a5f70.svg";